<template>
  <div class="aprv">
    <van-sticky>
      <van-tabs v-model="sel_state" color="#1989fa" @click="AddOptDates">
        <van-tab title="请假列表" />
        <van-tab title="加班列表" />
        <van-tab v-if="$store.getters.point_admin_power === '1'" title="积分列表" />
      </van-tabs>
      <van-dropdown-menu>
        <van-dropdown-item v-model="department" :options="opt_department" @change="ChangeSelectDepartment" />
        <van-dropdown-item v-model="sel_date" :options="opt_dates" :title="title_date" @change="ChangeSelectDate" />
        <van-dropdown-item v-model="sel_status" :options="opt_state" @change="ChangeSelectState" />
      </van-dropdown-menu>
      <van-popup v-model="picker.showDatePicker" position="bottom">
        <van-datetime-picker
          v-model="picker.currentDate"
          type="year-month"
          :min-date="picker.minDate"
          :max-date="picker.maxDate"
          @confirm="ConfirmDatePicker"
          @cancel="CancelDatePicker"
        />
      </van-popup>
    </van-sticky>
    <leave v-show="sel_state=='0'" ref="leave" />
    <overtime v-show="sel_state=='1'" ref="overtime" />
    <examinetableData v-show="sel_state=='2'" ref="tabledata" />
  </div>
</template>

<script>
import leave from './Aprv/Leave'
import overtime from './Aprv/OverTime'
import examinetableData from './EducationalPoints/ExamineTableData'
import request from '@/utils/request'
import { getUsercode } from '@/utils/auth'
import { GetAllUser } from '@/api/EducationalPoints'
const moment = require('moment')
export default {
  name: 'Aprv',
  components: { leave, overtime, examinetableData },
  data() {
    return {
      sel_state: 0,
      isLoading: false,
      department: '0',
      opt_department: [],
      department1: '0',
      opt_department1: [],
      sel_date: '4',
      sel_status: '0',
      title_department: '',
      title_date: '全部',
      picker: {
        minDate: new Date(2019, 0, 1),
        maxDate: new Date(moment().add(1, 'year').endOf('month')),
        currentDate: new Date(),
        showDatePicker: false
      },
      params: {
        approval: '0',
        user_code: this.$store.getters.usercode,
        work_date_s: 'ALL',
        work_date_e: 'ALL'
      },
      opt_dates: [
        { text: '本月', value: '0', icon: 'clock-o' },
        { text: '前月', value: '1', icon: 'clock-o' },
        { text: '全年', value: '2', icon: 'clock-o' },
        { text: '自定义', value: '3', icon: 'aim' },
        { text: '全部', value: '4', icon: 'clock-o' }
      ],
      opt_state: [
        { text: '等待审批', value: '0', icon: 'certificate' },
        { text: '历史记录', value: '1', icon: 'certificate' }
      ],
      freshHeight: '100%',
      Point_data_s: moment().startOf('month').format('YYYY-MM-DD'),
      Point_data_e: moment().endOf('month').format('YYYY-MM-DD')
    }
  },
  watch: {
    sel_status(newdata, olddata) {
      // 选中积分列表
      if (this.sel_state === 2) {
        console.log(this.sel_status)
        this.$store.dispatch('pointvuex/point_list', newdata)
      }
    }
  },
  created() {
    // 部门获取
    const self = this
    request({ url: '/C00/deptList', params: { user_code: getUsercode() }})
      .then(function(response) {
        self.opt_department = response.parm
        self.opt_department1 = response.parm
        self.department = response.parm[0].value
        self.department1 = response.parm[0].value
        self.title_department = response.data[0].text
      })
      .catch(() => { this.loading = false })
  },
  methods: {
    // 日期变更
    ChangeSelectDate(value) {
      if (this.sel_state !== 2) {
        switch (value) {
          case '0':
            this.params.work_date_s = moment().startOf('month').format('YYYY-MM-DD')
            this.params.work_date_e = moment().endOf('month').format('YYYY-MM-DD')
            this.title_date = this.opt_dates[value].text
            this.onRefresh()
            break
          case '1':
            this.params.work_date_s = moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD')
            this.params.work_date_e = moment().add(-1, 'month').endOf('month').format('YYYY-MM-DD')
            this.title_date = this.opt_dates[value].text
            this.onRefresh()
            break
          case '2':
            this.params.work_date_s = moment().startOf('year').format('YYYY-MM-DD')
            this.params.work_date_e = moment().endOf('year').format('YYYY-MM-DD')
            this.title_date = this.opt_dates[value].text
            this.onRefresh()
            break
          case '3':
            this.picker.showDatePicker = true
            this.sel_date = '9'
            break
          default:
            this.params.work_date_s = 'ALL'
            this.params.work_date_e = 'ALL'
            this.title_date = this.opt_dates[value].text
            this.onRefresh()
            break
        }
      } else {
        this.ChangePointSelectDate(value)
      }
    },
    ChangePointSelectDate(value) {
      switch (value) {
        // 本月
        case '0':
          this.title_date = this.opt_dates[value].text
          this.Point_data_s = moment().startOf('month').format('YYYY-MM-DD')
          this.Point_data_e = moment().endOf('month').format('YYYY-MM-DD')
          this.$refs.tabledata.getPointApplyInfo()
          break
        // 前月
        case '1':
          this.title_date = this.opt_dates[value].text
          this.Point_data_s = moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD')
          this.Point_data_e = moment().add(-1, 'month').endOf('month').format('YYYY-MM-DD')
          this.$refs.tabledata.getPointApplyInfo()
          break
        // 全年
        case '2':
          this.title_date = this.opt_dates[value].text
          this.Point_data_s = moment().startOf('year').format('YYYY-MM-DD')
          this.Point_data_e = moment().endOf('year').format('YYYY-MM-DD')
          this.$refs.tabledata.getPointApplyInfo()
          break
        // 自定义
        case '3':
          this.Point_data_s = ''
          this.Point_data_e = ''
          this.sel_date = ''
          this.picker.showDatePicker = true
          break
      }
    },
    // 自定义月份控件
    ConfirmDatePicker() {
      this.picker.showDatePicker = false
      // 本月
      if (moment(this.picker.currentDate).format('YYYY/MM') === moment().format('YYYY/MM')) {
        this.title_date = this.opt_dates[0].text
        this.sel_date = this.opt_dates[0].value
      // 前月
      } else if (moment(this.picker.currentDate).format('YYYY/MM') === moment().add(-1, 'month').format('YYYY/MM')) {
        this.title_date = this.opt_dates[1].text
        this.sel_date = this.opt_dates[1].value
      } else {
        this.title_date = moment(this.picker.currentDate).format('YYYY/MM')
        this.sel_date = ''
      }
      // 加班列表/请假列表
      if (this.sel_state !== 2) {
        this.params.work_date_s = moment(this.picker.currentDate).startOf('month').format('YYYY-MM-DD')
        this.params.work_date_e = moment(this.picker.currentDate).endOf('month').format('YYYY-MM-DD')
        this.onRefresh()
      // 积分列表
      } else {
        this.Point_data_s = moment(this.picker.currentDate).startOf('month').format('YYYY-MM-DD')
        this.Point_data_e = moment(this.picker.currentDate).endOf('month').format('YYYY-MM-DD')
        this.$refs.tabledata.getPointApplyInfo()
      }
    },
    CancelDatePicker() {
      this.picker.showDatePicker = false
    },
    // 状态变更
    ChangeSelectState(value) {
      // 场合 and 等待审批场合
      if (this.sel_state === 0 && this.sel_status === '0') {
        this.opt_dates = [
          { text: '本月', value: '0', icon: 'clock-o' },
          { text: '前月', value: '1', icon: 'clock-o' },
          { text: '全年', value: '2', icon: 'clock-o' },
          { text: '自定义', value: '3', icon: 'aim' },
          { text: '全部', value: '4', icon: 'clock-o' }
        ]
        // 加班列表场合
      } else if (this.sel_state === 1) {
        this.title_date = '本月'
        this.sel_date = '0'
        this.params.work_date_s = moment().startOf('month').format('YYYY-MM-DD')
        this.params.work_date_e = moment().endOf('month').format('YYYY-MM-DD')
        this.onRefresh()
        this.opt_dates = [
          { text: '本月', value: '0', icon: 'clock-o' },
          { text: '前月', value: '1', icon: 'clock-o' },
          { text: '全年', value: '2', icon: 'clock-o' },
          { text: '自定义', value: '3', icon: 'aim' }
        ]
      } else if (this.sel_state === 2) {
        this.$refs.tabledata.getPointApplyInfo()
      }
      switch (value) {
        case '0':
          this.params.approval = '0'
          this.onRefresh()
          break
        case '1':
          this.params.approval = '1'
          this.onRefresh()
          break
        default:
          this.params.approval = '0'
          this.onRefresh()
          break
      }
    },
    ChangeSelectDepartment(value) {
      // 加班列表或请假列表
      if (this.sel_state === 0 || this.sel_state === 1) {
        if (value === '0') {
          this.opt_department = this.opt_department1
          this.department = this.department1
          this.params.department = null
        } else {
          this.params.department = value
        }
        this.onRefresh()
      // 积分列表
      } else if (this.sel_state === 2) {
        this.$refs.tabledata.getPointApplyInfo()
      }
    },
    onRefresh() {
      this.$refs.leave.onRefresh()
      this.$refs.overtime.onRefresh()
    },
    // 请假列表 加班列表切换
    async AddOptDates() {
      // 请假列表场合 and 等待审批场合
      if (this.sel_state === 0) {
        this.opt_dates = [
          { text: '本月', value: '0', icon: 'clock-o' },
          { text: '前月', value: '1', icon: 'clock-o' },
          { text: '全年', value: '2', icon: 'clock-o' },
          { text: '自定义', value: '3', icon: 'aim' },
          { text: '全部', value: '4', icon: 'clock-o' }
        ]
        this.opt_state = [
          { text: '等待审批', value: '0', icon: 'certificate' },
          { text: '历史记录', value: '1', icon: 'certificate' }
        ]
        this.title_date = this.opt_dates[0].text
        this.sel_date = this.opt_dates[0].value
        this.params.work_date_s = moment().startOf('month').format('YYYY-MM-DD')
        this.params.work_date_e = moment().endOf('month').format('YYYY-MM-DD')
        this.sel_status = this.opt_state[0].value
        this.params.approval = this.opt_state[0].value
        this.onRefresh()
        // this.sel_status = this.opt_state[0].value
        // 部门获取
        const self = this
        request({ url: '/C00/deptList', params: { user_code: getUsercode() }})
          .then(function(response) {
            self.opt_department = response.parm
            self.opt_department1 = response.parm
            self.department = response.parm[0].value
            self.department1 = response.parm[0].value
            self.title_department = response.data[0].text
          })
          .catch(() => { this.loading = false })
      // 加班列表场合
      } else if (this.sel_state === 1) {
        this.opt_dates = [
          { text: '本月', value: '0', icon: 'clock-o' },
          { text: '前月', value: '1', icon: 'clock-o' },
          { text: '全年', value: '2', icon: 'clock-o' },
          { text: '自定义', value: '3', icon: 'aim' }
        ]
        this.opt_state = [
          { text: '等待审批', value: '0', icon: 'certificate' },
          { text: '历史记录', value: '1', icon: 'certificate' }
        ]
        this.params.work_date_s = moment().startOf('month').format('YYYY-MM-DD')
        this.params.work_date_e = moment().endOf('month').format('YYYY-MM-DD')
        this.title_date = this.opt_dates[0].text
        this.sel_date = this.opt_dates[0].value
        this.sel_status = this.opt_state[0].value
        this.params.approval = this.opt_state[0].value
        this.onRefresh()
        // 部门获取
        const self = this
        request({ url: '/C00/deptList', params: { user_code: getUsercode() }})
          .then(function(response) {
            self.opt_department = response.parm
            self.opt_department1 = response.parm
            self.department = response.parm[0].value
            self.department1 = response.parm[0].value
            self.title_department = response.data[0].text
          })
          .catch(() => { this.loading = false })
      // 积分列表
      } else if (this.sel_state === 2) {
        await this.DataArrangement()
        await this.getAllUser()
        this.$refs.tabledata.getPointApplyInfo()
      }
    },
    async DataArrangement() {
      this.opt_state = [
        { text: '未审批', value: '0', icon: 'clock-o' },
        { text: '已审批', value: '2', icon: 'passed' },
        { text: '已拒绝', value: '1', icon: 'close' }
      ]
      this.opt_dates = [
        { text: '本月', value: '0', icon: 'clock-o' },
        { text: '前月', value: '1', icon: 'clock-o' },
        { text: '全年', value: '2', icon: 'clock-o' },
        { text: '自定义', value: '3', icon: 'aim' }
      ]
      this.sel_date = this.opt_dates[0].value
      this.title_date = this.opt_dates[0].text
      this.sel_status = this.opt_state[0].value
    },
    // 获取全部在职人员
    async getAllUser() {
      const that = this
      await GetAllUser(function(res) {
        if (res.code === 0) {
          const array = { text: '全部', value: null }
          const value = JSON.parse(JSON.parse(res.data))
          var newArr = value.map(item => ({
            text: item.user_name + '(' + item.user_code + ')',
            value: item.user_code
          }))
          that.opt_department = newArr
          that.opt_department.unshift(array)
          that.department = that.opt_department[0].value
        } else {
          that.opt_department = []
          that.department = ''
        }
      })
    }
  }
}
</script>
<style scoped>
  .font-size1{
    font-size:1px
  }
</style>
